<rect x="1" y="7.25735" width="34" height="35" rx="7" fill="currentColor" />
<path
    d="M31.6751 24.659L48.3364 7.64053L48.4247 41.5905L31.6751 24.659Z"
    fill="currentColor"
/>
